import { render } from "./EmpresasStatusDropdown.vue?vue&type=template&id=2bbd7e70"
import script from "./EmpresasStatusDropdown.vue?vue&type=script&lang=js"
export * from "./EmpresasStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__